// removed by extract-text-webpack-plugin
module.exports = {"Image":"BgVt3x0x","border":"j1fVVQIl","round":"_3WDq-rjn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/image/image-component.styles.scss
// module id = 232
// module chunks = 0